var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"ma-6 pa-6 pb-4",attrs:{"outlined":""}},[_c('SmsHitoryFilter',{on:{"onFilterChanged":_vm.onFilterChanged}})],1),_c('v-card',{staticClass:"ma-6",attrs:{"outlined":""}},[_c('SmsHistoryDatatable',{ref:"table"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }